import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { LOCALE } from '../const/translations/LOCALE';
import { LOCALE_NAMESPACE } from '../const/translations/LOCALE_NAMESPACE';

import authEn from './en/auth.json';
import authNl from './nl/auth.json';
import authDe from './de/auth.json';
import authLt from './lt/auth.json';

import commonEn from './en/common.json';
import commonNl from './nl/common.json';
import commonDe from './de/common.json';
import commonLt from './lt/common.json';

import subscriptionsEn from './en/subscriptions.json';
import subscriptionsNl from './nl/subscriptions.json';
import subscriptionsDe from './de/subscriptions.json';
import subscriptionsLt from './lt/subscriptions.json';

const resources = {
    en: {
        [LOCALE_NAMESPACE.AUTH]: authEn,
        [LOCALE_NAMESPACE.COMMON]: commonEn,
        [LOCALE_NAMESPACE.SUBSCRIPTIONS]: subscriptionsEn,
    },
    nl: {
        [LOCALE_NAMESPACE.AUTH]: authNl,
        [LOCALE_NAMESPACE.COMMON]: commonNl,
        [LOCALE_NAMESPACE.SUBSCRIPTIONS]: subscriptionsNl,
    },
    de: {
        [LOCALE_NAMESPACE.AUTH]: authDe,
        [LOCALE_NAMESPACE.COMMON]: commonDe,
        [LOCALE_NAMESPACE.SUBSCRIPTIONS]: subscriptionsDe,
    },
    lt: {
        [LOCALE_NAMESPACE.AUTH]: authLt,
        [LOCALE_NAMESPACE.COMMON]: commonLt,
        [LOCALE_NAMESPACE.SUBSCRIPTIONS]: subscriptionsLt,
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: LOCALE.EN,
        defaultNS: LOCALE_NAMESPACE.COMMON,
        supportedLngs: Object.values(LOCALE),
        fallbackLng: [LOCALE.EN],
    });

export default i18n;
